module.exports = __webpack_public_path__ + "img/aeroland-client-logo-08.2dcfe7e6.png";